import { Directive, ElementRef, HostListener, Self } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';
import { MonthCV } from '../model/cv/MonthCV.model';
import { TranslateService } from '@ngx-translate/core';
import { SSIMDateUtils } from '../util/SSIMDateUtil';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDate]'
})
export class AppDateDirective extends AppAbstractDirective {

  private months: MonthCV;

  constructor(
    @Self() private ngControl: NgControl,
    private element: ElementRef,
    private translateService: TranslateService
  ) {
    super();
    this.months = new MonthCV(translateService);
  }

  @HostListener('change', ['$event']) onChange(): void {

    const actualValue: string = this.element.nativeElement.value;
    if (actualValue.length !== 0 && actualValue.length <= 6) {
      const ssimDate: string = SSIMDateUtils.getSSIMFromIncompleteString(actualValue, this.translateService);
      if (ssimDate) {
        this.ngControl.control.setValue(ssimDate);
      } else {
        setTimeout(() => {
          this.element.nativeElement.focus();
        }, 10);
      }
    }
  }

  @HostListener('keypress', ['$event']) onkeyup(event: KeyboardEvent): boolean {

    let position: number = this.element.nativeElement.selectionStart;
    let previousValue: string = this.element.nativeElement.value;

    if (this.element.nativeElement.selectionEnd !== previousValue.length) { return; }

    if (position === 0 && this.element.nativeElement.selectionEnd === previousValue.length) {
      this.element.nativeElement.value = '';
      previousValue = '';
      position = this.element.nativeElement.selectionStart;
    }

    if (previousValue.length >= 5) {
      return false;
    }

    let newValue: string = previousValue + event.key;

    if (event.key >= '0' && event.key <= '9') {

      if (previousValue.length >= 2) {
        return false;
      }

      if (position === 0) {
        if (event.key !== '0' && event.key !== '1' && event.key !== '2' && event.key !== '3') {
          return true;
        }
      } else if (position === 1) {
        if (previousValue === '3' && event.key !== '0' && event.key !== '1') {
          return false;
        } else if (previousValue === '0' && event.key === '0') {
          return false;
        } else if (previousValue !== '0' && previousValue !== '1' && previousValue !== '2' && previousValue !== '3') {
          return false;
        }
      }

    } else if (this.isLetter(event.key)) {

      if (position === 0 || position === 1 || position === 2) {
        let dayString = '01';
        if (position === 1) {
          dayString = '0' + previousValue;
        } else if (position === 2) {
          dayString = previousValue;
        }
        this.element.nativeElement.value = dayString;
        previousValue = dayString;
        position = this.element.nativeElement.selectionStart;
        newValue = dayString + event.key;
      }

      const ssimDate: string = SSIMDateUtils.getSSIMFromIncompleteString(newValue, this.translateService);
      if (!ssimDate) {
        return false;
      }

    } else {
      return false;
    }

  }

  private isLetter(character: string) {
    return ((character >= 'a' && character <= 'z') || (character >= 'A' && character <= 'Z'));
  }

}
